/**
 * Precarga chunks de rutas lazy al pasar el mouse por el menú (navegación más rápida).
 */
const ROUTE_PRELOADERS: Record<string, () => Promise<unknown>> = {
  "/dashboard": () => import("@/pages/DashboardPage"),
  "/caja": () => import("@/pages/caja/CajaPage"),
  "/caja/ventas": () => import("@/pages/caja/CajaVentasPage"),
  "/caja/cierres": () => import("@/pages/caja/CajaCierresPage"),
  "/caja/movimientos": () => import("@/pages/caja/CajaMovimientosPage"),
  "/caja/creditos": () => import("@/pages/caja/CajaCreditosPage"),
  "/caja/fidelizacion": () => import("@/pages/caja/FidelizacionPage"),
  "/inventario": () => import("@/pages/inventory/InventoryPage"),
  "/inventario/promociones": () => import("@/pages/inventory/PromocionesPage"),
  "/personal": () => import("@/pages/personal/PersonalPage"),
  "/personal/tareas": () => import("@/pages/personal/PersonalTareasPage"),
  "/personal/asistencia": () =>
    import("@/pages/personal/PersonalAsistenciaPage"),
  "/personal/nomina": () => import("@/pages/personal/NominaPage"),
  "/personal/calendario": () =>
    import("@/pages/personal/PersonalCalendarioPage"),
  "/personal/vacantes": () => import("@/pages/personal/VacantesPage"),
  "/buzon-equipo": () => import("@/pages/personal/BuzonEquipoPage"),
  "/higiene": () => import("@/pages/higiene/HigienePage"),
  "/auditoria": () => import("@/pages/auditoria/AuditoriaPage"),
  "/metricas": () => import("@/pages/metrics/MetricasPage"),
  "/ia": () => import("@/pages/ia/IAPage"),
  "/mesas": () => import("@/pages/mesas/MeseroPage"),
  "/mesas/ordenes": () => import("@/pages/mesas/OrdenesMesaPage"),
  "/mesas/cocina": () => import("@/pages/mesas/CocinaPage"),
  "/mesas/configuracion": () => import("@/pages/mesas/MesasConfigPage"),
  "/calificaciones": () =>
    import("@/pages/calificaciones/CalificacionesAdminPage"),
  "/tienda/configuracion": () =>
    import("@/pages/tienda/TiendaConfiguracionPage"),
  "/tienda/pedidos": () => import("@/pages/tienda/PedidosPage"),
};

/** Precarga el chunk de la ruta (y prefijos conocidos). */
export function preloadRoute(path: string): void {
  if (ROUTE_PRELOADERS[path]) {
    void ROUTE_PRELOADERS[path]();
    return;
  }
  let best: (() => Promise<unknown>) | null = null;
  let bestLen = 0;
  for (const [prefix, loader] of Object.entries(ROUTE_PRELOADERS)) {
    if (path.startsWith(prefix + "/") && prefix.length > bestLen) {
      best = loader;
      bestLen = prefix.length;
    }
  }
  if (best) void best();
}
